
import './App.css';
import Pages from './Pages';

function App() {
  
 

  return (
    <div>
    <div className="App">
      <Pages />
      <div class="footer">
  <p>Designed by Mariusz Szkaradek</p>
</div>
    </div>
    </div>

  );
  }


export default App;
